export const GetFileExtension = (file: File): string => file.name.includes(".") ? file.name.split(".").pop() ?? "" : "";

const BASE64_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

export function base64ToUint8Array(base64: string): ArrayBuffer {
  const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, "=");
  const result: number[] = [];
  for (let i = 0; i < padded.length; i += 4) {
    const c1 = BASE64_CHARS.indexOf(padded[i]);
    const c2 = BASE64_CHARS.indexOf(padded[i + 1]);
    const c3 = BASE64_CHARS.indexOf(padded[i + 2]);
    const c4 = BASE64_CHARS.indexOf(padded[i + 3]);
    result.push((c1 << 2) | (c2 >> 4));
    if (padded[i + 2] !== "=") result.push(((c2 & 0xf) << 4) | (c3 >> 2));
    if (padded[i + 3] !== "=") result.push(((c3 & 0x3) << 6) | c4);
  }
  const buffer = new ArrayBuffer(result.length);
  const bytes = new Uint8Array(buffer);
  result.forEach((v, i) => { bytes[i] = v; });
  return buffer;
}